import { NgModule } from '@angular/core';
import { RoundPipe } from './round.pipe';
import { RoundSigPipe } from './roundsig.pipe';
import { NumPipe, PercPipe } from './perc.pipe';
import { ShowPipe } from './show.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';
import { YesnoPipe } from './yesno.pipe';
import { DurationFormatPipe } from './durationformat.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { RounddecimalPipe, RoundpercentPipe } from './rounddecimal.pipe';
import { UrlfixPipe } from './urlfix.pipe';
import { MonthstoyearsPipe } from './monthstoyears.pipe';
import { AbPercPipe } from './abperc.pipe';
import { RankinggriddatahtmlPipe } from './rankinggriddatahtml.pipe';
import { RoundSigRangePipe } from './roundsigrange.pipe';
import { InsightsRouterLinkPipe } from './insightsrouterlink.pipe';
import { PlatformAwareScalerPipe } from './platform-aware-scaler.pipe';
import { DetectednotdetectedPipe } from './detectednotdetected.pipe';
import { AbsolutePipe } from './absolutepipe';
import { SkipColumnPipe } from './skip-column.pipe';
import { ValidDatePipe } from './valid-date.pipe';
import { IconMapperPipe } from './icon-mapper.pipe';
import { ContainsValuePipe } from './contains-value';
import { ExtractDomainPipe } from './extractdomain.pipe';
import { FilterPipe } from './filter.pipe';
import { SortByPipe } from './sort-by.pipe';
import { RegionLabelMapPipe } from './region-label-map.pipe';
import { ArrayContainsValuePipe } from './array-contains-value';
import { DeviceLabelMapPipe } from './device-label-map.pipe';
import { TimeFormatPipe } from './timeformat.pipe';
import { TypeLabelMapPipe } from './type-label-map.pipe';
import { RatioFormatPipe } from './ratioformat.pipe';
import { HitIconPipe } from './hit-icon.pipe';
import { StripNlnlPipe } from './strip-nlnl.pipe';
import { RiskOverviewMapPipe } from './risk-overview-map.pipe';
import { AppStoreMapPipe } from './app-store-map.pipe';
import { IsNaNPipe } from './is-nan.pipe';
import { PlatformMapPipe } from './platform-map.pipe';
import { PercentPipe } from '@angular/common';
import { PxPercentPipe } from './pxpercent.pipe';
import { GroupLabelMap } from './group-label-map.pipe';
import { HighlightPipe } from './highlight.pipe';
import { CapitalizeAppStorePipe } from './capitalize-app-store.pipe';
import { NormalizeSelectorPipe } from './normalize-selector.pipe';
import { CapitalizeWordsPipe } from './capitalize-words.pipe';
import { ShowColumnIfPipe } from './show-column-if.pipe';

@NgModule({
  imports: [],
  declarations: [
    RoundPipe,
    RoundSigPipe,
    RoundSigRangePipe,
    NumPipe,
    ShowPipe,
    SkipColumnPipe,
    PercPipe,
    SafeHtmlPipe,
    YesnoPipe,
    DurationFormatPipe,
    CapitalizePipe,
    CapitalizeAppStorePipe,
    RounddecimalPipe,
    UrlfixPipe,
    RoundpercentPipe,
    MonthstoyearsPipe,
    AbPercPipe,
    RankinggriddatahtmlPipe,
    InsightsRouterLinkPipe,
    DetectednotdetectedPipe,
    PlatformAwareScalerPipe,
    AbsolutePipe,
    ValidDatePipe,
    IconMapperPipe,
    ContainsValuePipe,
    ArrayContainsValuePipe,
    ExtractDomainPipe,
    FilterPipe,
    SortByPipe,
    RegionLabelMapPipe,
    DeviceLabelMapPipe,
    TimeFormatPipe,
    TypeLabelMapPipe,
    RatioFormatPipe,
    HitIconPipe,
    StripNlnlPipe,
    RiskOverviewMapPipe,
    AppStoreMapPipe,
    IsNaNPipe,
    PlatformMapPipe,
    PxPercentPipe,
    GroupLabelMap,
    HighlightPipe,
    NormalizeSelectorPipe,
    CapitalizeWordsPipe,
    ShowColumnIfPipe
  ],
  exports: [
    RoundPipe,
    RoundSigPipe,
    RoundSigRangePipe,
    NumPipe,
    ShowPipe,
    SkipColumnPipe,
    PercPipe,
    SafeHtmlPipe,
    YesnoPipe,
    DurationFormatPipe,
    CapitalizePipe,
    CapitalizeAppStorePipe,
    RounddecimalPipe,
    UrlfixPipe,
    RoundpercentPipe,
    MonthstoyearsPipe,
    AbPercPipe,
    RankinggriddatahtmlPipe,
    InsightsRouterLinkPipe,
    DetectednotdetectedPipe,
    PlatformAwareScalerPipe,
    AbsolutePipe,
    ValidDatePipe,
    IconMapperPipe,
    ContainsValuePipe,
    ArrayContainsValuePipe,
    ExtractDomainPipe,
    FilterPipe,
    SortByPipe,
    RegionLabelMapPipe,
    DeviceLabelMapPipe,
    TimeFormatPipe,
    TypeLabelMapPipe,
    RatioFormatPipe,
    HitIconPipe,
    StripNlnlPipe,
    RiskOverviewMapPipe,
    AppStoreMapPipe,
    IsNaNPipe,
    PlatformMapPipe,
    PxPercentPipe,
    GroupLabelMap,
    HighlightPipe,
    NormalizeSelectorPipe,
    CapitalizeWordsPipe,
    ShowColumnIfPipe
  ],
  providers: [PercentPipe]
})
export class PipesModule {}
